import { render, staticRenderFns } from "./rightSidebar.vue?vue&type=template&id=8e8cdafe"
import script from "./rightSidebar.vue?vue&type=script&lang=js"
export * from "./rightSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports